/*******
  Exports ReactiveFormsModule & FormsModule from @angular/forms as well as those
  custom form fields components.

  If we are importing this module into any other, is not necessary to import
  ReactiveFormsModule or FormsModule again.
******/

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MaterialModule } from './material.module';
import { SweetAlert2Module } from '@sweetalert2/ngx-sweetalert2';
import { PipesDirectivesModule } from './pipes-directives.module';
import { FlexLayoutModule } from '@angular/flex-layout';
import { RouterModule } from '@angular/router';
import { NgxUploaderModule } from 'ngx-uploader';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { MaskitoDirective } from '@maskito/angular';

// Required for Dynamic Components
import { DynamicOutletComponent } from '../../dynamic-component-loader/dynamic-outlet/dynamic-outlet.component';

// Components
import { DeleteComponent } from '../../components/delete/delete.component';
import { DecimalFieldComponent } from '../../components/forms/decimal-field/decimal-field.component';
import { CurrencyFieldComponent } from '../../components/forms/currency-field/currency-field.component';
import { CheckboxComponent } from '../../components/checkbox/checkbox.component';
import { CheckboxListComponent } from '../../components/checkbox-list/checkbox-list.component';
// tslint:disable-next-line:max-line-length
import { PeriodAnnualRentComponent } from '../../components/fees-split/fees/standard-fee/period-annual-rent/period-annual-rent.component';
import { BrokerSearchFieldComponent } from '../../components/broker-search-field/broker-search-field.component';
import { AvatarComponent } from '../../components/user-profile-settings/avatar/avatar.component';
import { RentReviewComponent } from '../../components/rent-review/rent-review.component';
import { LeaseIncentiveComponent } from '../../components/lease-incentive/lease-incentive.component';
import { FileUploadComponent } from '../../components/file-upload/file-upload.component';
import { RadioButtonOptionComponent } from '../../components/radio-button-option/radio-button-option.component';
import { UploadListComponent } from '../../components/upload-list/upload-list.component';
import { UploadListButtonComponent } from '../../components/upload-list-button/upload-list-button.component';
import { UploadListDialogComponent } from '../../components/upload-list-dialog/upload-list-dialog.component';
import { ContactFieldComponent } from '../../components/forms/contact-field/contact-field.component';
import { CustomFileSelectDirective } from '../../utils/ngx-uploader/custom-file-select.directive';
import { CustomFileDropDirective } from '../../utils/ngx-uploader/custom-file-drop.directive';
import { GstFeeComponent } from '../../components/fees-split/fees/gst-fee/gst-fee.component';
import { PaymentDuedateComponent } from '../../components/payment-duedate/payment-duedate.component';
import { AutocompleteComponent } from '../../components/forms/autocomplete/autocomplete.component';
import { DatepickerFieldComponent } from '../../components/forms/datepicker-field/datepicker-field.component';
import { AddressDropdownComponent } from '../../components/forms/address-dropdown/address-dropdown.component';
import { CompanyContactFieldComponent } from '../../components/forms/company-contact-field/company-contact-field.component';
import { MultiselectAutocompleteComponent } from '../../components/multiselect-autocomplete/multiselect-autocomplete.component';
import { SalesforceAccountNameComponent } from '../../components/parties/salesforce-account-name/salesforce-account-name.component';
import { AmlChecklistQuestionComponent } from '../../components/customer/aml-checklist-question/aml-checklist-question.component';
import { PortfolioNameComponent } from '../../components/forms/portfolio-name/portfolio-name.component';

@NgModule({
    declarations: [
        DynamicOutletComponent,
        CheckboxComponent,
        CheckboxListComponent,
        PeriodAnnualRentComponent,
        DecimalFieldComponent,
        CurrencyFieldComponent,
        DeleteComponent,
        BrokerSearchFieldComponent,
        AvatarComponent,
        RentReviewComponent,
        LeaseIncentiveComponent,
        FileUploadComponent,
        RadioButtonOptionComponent,
        UploadListComponent,
        UploadListButtonComponent,
        UploadListDialogComponent,
        ContactFieldComponent,
        CustomFileSelectDirective,
        CustomFileDropDirective,
        GstFeeComponent,
        PaymentDuedateComponent,
        AutocompleteComponent,
        DatepickerFieldComponent,
        AddressDropdownComponent,
        CompanyContactFieldComponent,
        MultiselectAutocompleteComponent,
        SalesforceAccountNameComponent,
        AmlChecklistQuestionComponent,
        PortfolioNameComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        SweetAlert2Module.forRoot({
        // confirmButtonColor: '#00a657',
        // cancelButtonColor: '#747474',
        }),
        PipesDirectivesModule,
        FlexLayoutModule,
        MaterialModule,
        RouterModule,
        NgxUploaderModule,
        NgxMatSelectSearchModule,
        MaskitoDirective
    ],
    exports: [
        FormsModule,
        ReactiveFormsModule,
        SweetAlert2Module,
        DynamicOutletComponent,
        CheckboxComponent,
        CheckboxListComponent,
        PeriodAnnualRentComponent,
        DecimalFieldComponent,
        CurrencyFieldComponent,
        DeleteComponent,
        BrokerSearchFieldComponent,
        AvatarComponent,
        RentReviewComponent,
        LeaseIncentiveComponent,
        FileUploadComponent,
        RadioButtonOptionComponent,
        UploadListComponent,
        UploadListButtonComponent,
        ContactFieldComponent,
        CustomFileSelectDirective,
        CustomFileDropDirective,
        GstFeeComponent,
        PaymentDuedateComponent,
        AutocompleteComponent,
        DatepickerFieldComponent,
        AddressDropdownComponent,
        CompanyContactFieldComponent,
        MultiselectAutocompleteComponent,
        SalesforceAccountNameComponent,
        AmlChecklistQuestionComponent,
        MaskitoDirective,
        PortfolioNameComponent
    ]
})
export class FormComponentsModule { }
